// extracted by mini-css-extract-plugin
var _1 = "x6TMr";
export { _1 as "list" }
